import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMorvaridEnrollIconPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={92}
    height={93}
    fill='none'
    {...props}
  >
    <g filter='url(#morvaridEnrollIconPwa_svg__a)'>
      <path
        fill='url(#morvaridEnrollIconPwa_svg__b)'
        d='M0 0h80v80H0z'
        shapeRendering='crispEdges'
        transform='matrix(-1 0 0 1 86 4.5)'
      />
    </g>
    <defs>
      <pattern
        id='morvaridEnrollIconPwa_svg__b'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#morvaridEnrollIconPwa_svg__c' transform='scale(.00125 .00129)' />
      </pattern>
      <filter
        id='morvaridEnrollIconPwa_svg__a'
        width={92}
        height={92}
        x={0}
        y={0.5}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_15915_48178' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_15915_48178' result='shape' />
      </filter>
      <image
        xlinkHref='/images/icons/morvarid-enroll-icon-9953b396.webp'
        id='morvaridEnrollIconPwa_svg__c'
        width={802}
        height={775}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgMorvaridEnrollIconPwa;
